import { FC } from 'react';
import { css } from '@emotion/react';
import { Typography, TypographyProps } from 'client/components/Typography';

const subheaderStyle = css`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  padding: 0 16px;
  user-select: none;

  a + &,
  li + & {
    margin-top: 24px;
  }

  > svg {
    transform: translateY(1px);
  }
`;

export interface ListSubheaderProps extends TypographyProps {}

export const ListSubheader: FC<ListSubheaderProps> = ({ children, ...props }) => (
  <Typography component="li" variant="body2" css={subheaderStyle} {...props}>
    {children}
  </Typography>
);
